
































































import {
    defineComponent,
    inject,
    watch,
    computed,
    ref,
    onMounted,
} from '@vue/composition-api'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as InputStoreKey } from '@/store/Input'
import { StoreKey as ErrorStoreKey } from '@/store/Error'
import { StoreKey as ValidatedStoreKey } from '@/store/Validated'

// Util
import { useValidate } from '@/ts/util/validate'

export default defineComponent({
    setup() {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }
        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const validateHandler = useValidate(
            { required: ref(true) },
            (result, flag) => {
                validatedStore.first_time = flag

                const messages: string[] = []
                if (result.required === false) {
                    messages.push(
                        formStore.error_message.error_first_time ||
                            'ご来店が初めてかどうかご選択ください'
                    )
                }

                if (messages.length) {
                    errorStore.first_time.value = [...messages]
                } else {
                    errorStore.first_time.value = null
                }
            }
        )

        const inputFieldClass = computed(() => {
            return {
                'm-invalid':
                    errorStore.first_time.value !== null ||
                    validatedStore.first_time === -1,
                'm-verify': validatedStore.first_time === 1,
            }
        })

        onMounted(() => {
            if (inputStore.first_time) {
                validateHandler(inputStore.first_time)
            }
        })

        return {
            formStore,
            inputStore,
            errorStore,
            validatedStore,
            inputFieldClass,
            validateHandler,
        }
    },
})
